import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { compactInteger } from '@shared/utils/strings';

@Pipe({
    name: 'appCompactInteger'
})
export class CompactIntegerPipe implements PipeTransform {

    transform(value: any, ...args: unknown[]): unknown {
        return compactInteger(value, 1);
    }

}
